/* eslint-disable react-hooks/exhaustive-deps */
import Avatar from 'funifier-nice-avatar';

import { PointReviewItem } from 'components/point-review-item';
import { RewardReviewItem } from 'components/reward-review-item';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Box from 'components/ui/box';
import { useEffect, useState } from 'react';
import { RiArrowLeftSLine } from 'react-icons/ri';
import { getMissaoGestorPublic, getMissaoEquipePublic } from 'services/achievement.service';
import { getKPIPublicHistoryByTime, getPlayerInfo, getSeloRealizacaoDetail } from 'services/dashboard.service';
import { getPublicProfile } from 'services/profile.service';
import { RedePoint } from 'pages/Rede/components/point';
import { PointItem } from 'components/point-item';
import Humanograma from 'components/Humanograma';
import { getLevelTitle } from 'services/utils';
import Tippy from '@tippyjs/react';
import { BiInfoCircle } from 'react-icons/bi';
import { useModal } from 'context/ModalContext';
import { GroupDetailModalExtrato } from 'components/group-detail-modal-extrato';
import { isGrupoValido } from 'utils/helpers';
import { SeloRealizacao } from 'components/icons';

interface GaleriaConhecimentoDetailProps {
  id?: string;
  tab: string;
  data: any;
  active: any;
  onClose: () => void;
}
export function RealizacaoDetail({ id, tab, data, active, onClose }: GaleriaConhecimentoDetailProps) {
  const [user, setUser] = useState<any>();
  const [userInfo, setUserInfo] = useState<any>();
  const [task, setTask] = useState<any>([]);

  const { showModal } = useModal();

  const [loadingMissionList, setLoadingMissionList] = useState(true);

  useEffect(() => {
    if (!id) {
      return;
    }

    async function loadPlayerInfo() {
      if (!id) return;

      const userProfile = await getPublicProfile(id, active.value);
      const playerInfo = await getPlayerInfo(id);
      setUserInfo(playerInfo);
      setUser(userProfile);

      if (tab === 'coletiva') {
        const _task = await getSeloRealizacaoDetail(id, active.value);
        setTask(_task);
      }

      if (tab === 'premiacao') {
        if (userProfile?.type === 'PREDEFINIDO') {
          setLoadingMissionList(false);
          return;
        }

        const isGestor =
          playerInfo.tipo_ro === 'GERENCIAL' ||
          playerInfo.funcao === 'DIRETOR' ||
          (Array.isArray(playerInfo.mad_dupla) &&
            playerInfo.mad_dupla.some((md: any) => typeof md.tipo_ro === 'string' && md.tipo_ro === 'GERENCIAL'));

        if (isGestor) {
          const dataGestor = await getMissaoGestorPublic(id, active.date_start, active.date_end, active.value);
          const dataEquipe = await getMissaoEquipePublic(id, active.date_start, active.date_end, active.value);
          setTask([...dataGestor, ...dataEquipe]);
        } else {
          const _data = await getMissaoEquipePublic(id, active.date_start, active.date_end, active.value);
          setTask(_data);
        }
      }

      if (tab === 'selo') {
        const isGestor =
          playerInfo.tipo_ro === 'GERENCIAL' ||
          playerInfo.funcao === 'DIRETOR' ||
          (Array.isArray(playerInfo.mad_dupla) &&
            playerInfo.mad_dupla.some((md: any) => typeof md.tipo_ro === 'string' && md.tipo_ro === 'GERENCIAL'));

        if (isGestor) {
          const dataGestor = await getMissaoGestorPublic(id, active.date_start, active.date_end, active.value);
          const dataEquipe = await getMissaoEquipePublic(id, active.date_start, active.date_end, active.value);
          const _dataGestor = dataGestor
            .filter((item: any) => item.task.status === 'selo')
            .map((e: any) => ({
              total: e.totalMissao,
              titulo: e.task.title,
              descricao: e.task.description,
              status: 'selo',
              type: 'selo_realizacao',
            }));

          const _dataEquipe = dataEquipe
            .filter((item: any) => item.status === 'selo')
            .map((e: any) => ({
              total: e.totalMissao,
              titulo: e.titulo,
              descricao: e.descricao,
              status: 'selo',
              type: 'selo_realizacao',
            }));

          setTask([..._dataGestor, ..._dataEquipe]);
        } else {
          const _data = await getMissaoEquipePublic(id, active.date_start, active.date_end, active.value);
          const _dataEquipe = _data
            .filter((item: any) => item.status === 'selo')
            .map((e: any) => ({
              total: e.totalMissao,
              titulo: e.titulo,
              descricao: e.descricao,
              status: 'selo',
              type: 'selo_realizacao',
            }));
          setTask(_dataEquipe);
        }
      }

      setLoadingMissionList(false);
    }

    loadPlayerInfo();
  }, [id]);

  function getTitle() {
    if (tab === 'premiacao') {
      return 'Premiação em Espécie';
    }

    if (tab === 'coletiva') {
      return 'Realizações Coletivas';
    }

    return 'Selos';
  }

  function getSubTitle() {
    if (tab === 'premiacao') {
      return (
        <h2 className="text-2xl mb-3" tabIndex={0}>
          <p className="block">
            Faixa de premiação {data?.faixa}
          </p>

          {/* <p>
            Realizações Destaque que geraram premiação <b className="text-yellow">Faixa {data?.faixa}</b>
          </p> */}

          {!loadingMissionList && user?.type !== 'HIBRIDO' && (
            <div className="mt-5 flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
              <p className="block text-sm">
                Premiação para funcionários avaliados por acordos individuais do tipo predefinido
              </p>
            </div>
          )}
        </h2>
      );
    }

    if (tab === 'coletiva') {
      return (
        <h2 className="text-2xl mb-3" tabIndex={0}>
          Realização Destaque com premiação coletiva
        </h2>
      );
    }

    return (
      <h2 className="text-2xl mb-3" tabIndex={0}>
        Selos conquistados em Realizações Destaque
      </h2>
    );
  }

  return (
    <div className="mx-auto container p-3 lg:p-10">
      <div className="flex flex-row items-center space-x-3 lg:space-x-2 mb-3 lg:mb-10">
        <button
          onClick={() => onClose()}
          className="rounded-full bg-purple flex justify-center items-center p-1"
          aria-label="Voltar para realizações"
        >
          <RiArrowLeftSLine size={28} className="text-white" aria-hidden="true" />
        </button>
        <h1 className="text-lg lg:text-3xl py-1 px-6" tabIndex={0}>
          {getTitle()}
        </h1>
      </div>

      {userInfo && (
        <div className="bg-oxford-blue rounded-3xl p-10 mb-10 flex flex-col lg:flex-row space-y-3 justify-between">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-3 text-center lg:text-left">
            <div className="w-28 h-28 md:w-44 md:h-44 bg-purple flex items-center justify-center rounded-full overflow-hidden text-3xl md:text-6xl">
              {!!user.extra.avatar_type &&
                (user.image ? <img src={user.image.medium.url} alt={user.name} className="w-full h-full" /> : user.name[0])}
              {!user.extra.avatar_type &&
                (!!user.extra.avatar ? <Avatar className="w-full h-full" {...user.extra.avatar} /> : user.name[0])}
            </div>
            <div className="space-y-3">
              <Humanograma data={{ ...userInfo, _id: userInfo?.chave }}>
                <div className="text-lg md:text-2xl text-white font-bold">
                  <span>
                    {userInfo?.nome_guerra} <span className="font-thin">({user?._id})</span>
                  </span>
                </div>
              </Humanograma>
              {userInfo && (
                <div className="md:text-xl font-thin">
                  {user?.level && !!isGrupoValido(user?.grupo) && (
                    <div className="mb-4 flex items-center">
                      <span tabIndex={0}>
                        Nível: <b className="text-electric-blue">{getLevelTitle(user?.level)}</b>{' '}
                      </span>
                      <Tippy
                        arrow={true}
                        allowHTML={true}
                        className="bg-black text-white font-thin rounded-xl p-2 tippy"
                        content={<>Nível definido.</>}
                      >
                        <span className="ml-2" aria-label="Nível definido">
                          <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" aria-hidden="true" />
                        </span>
                      </Tippy>
                    </div>
                  )}

                  {user?.grupo ? (
                    <button
                      className="flex items-center space-x-2 text-left"
                      onClick={() => showModal('group-detail-extrato')}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          showModal('group-detail-extrato');
                        }
                      }}
                      aria-label={`Ver detalhes do grupo ${user?.grupo}, ${user?.grupo_total || userInfo?.grupo?.total} funcionários`}
                    >
                      <span>{user?.grupo ? user.grupo : userInfo?.grupo?.nome}</span>{' '}
                      <span>({user?.grupo_total ? user?.grupo_total : userInfo?.grupo?.total} funci) </span>{' '}
                      <Tippy
                        arrow={true}
                        allowHTML={true}
                        className="bg-black text-white font-thin rounded-xl p-2 tippy"
                        content={<>O seu grupo de classificação está definido.</>}
                      >
                        <span className="ml-2" aria-label="O seu grupo de classificação está definido">
                          <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" aria-hidden="true" />
                        </span>
                      </Tippy>
                      <span className="font-bold text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-electric-blue">
                        {userInfo?.ro}
                      </span>
                    </button>
                  ) : (
                    <div className="md:text-xl font-thin">
                      <span>{userInfo?.grupo?.nome}</span> <span>({userInfo?.grupo?.total} funci)</span>{' '}
                      <span className="font-bold text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-electric-blue">
                        {userInfo?.ro}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {tab === 'selo' && !!active?.label && (
            <div
              className="flex flex-col justify-center items-center space-y-4"
              tabIndex={0}
              role="img"
              aria-label="Selo conquistado: Realização Destaque"
            >
              <div aria-hidden="true">
                <SeloRealizacao size={'114px'} cycle={active.label} />
              </div>
              <b className="text-xl text-yellow" aria-hidden="true">Selo conquistado</b>
            </div>
          )}
        </div>
      )}

      {getSubTitle()}

      <div className="w-full flex flex-col space-y-5">
        <div className="space-y-5">
          {loadingMissionList ? (
            <div className="space-y-2">
              <ArticlePlaceholder />
              <ArticlePlaceholder />
            </div>
          ) : null}

          {!loadingMissionList && !task?.length && data?.task && (
            <div className="space-y-2">
              <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                <PointItem data={data.task} cycleLabel={active.label} />
              </div>
            </div>
          )}

          {!loadingMissionList && task?.length > 0 && (
            <div className="space-y-2">
              <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                {task?.map((item: any) => (
                  <PointItem
                    key={item._id}
                    data={{
                      ...item,
                      type:
                        item?.type && item.type !== 'selo_realizacao'
                          ? 'realizaca_premiada'
                          : item.type === 'selo_realizacao'
                            ? 'selo_realizacao'
                            : 'realizaca_premiada_coletiva',
                    }}
                    cycleLabel={active.label}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {user?._id && user?.grupo && <GroupDetailModalExtrato player={user?._id} cycleLabel={active?.label} />}
    </div>
  );
}
